import { BrowserRouter } from "react-router-dom";
import { AppContextProvider } from "./components/AppContext";
import { Navigation } from "./components/Navigation";
import { Routes } from "./components/Routes";
import ThemeSwitcher from "./components/ThemeSwitcher";
import Snowfall from "./components/Snowfall";

function App() {
  return (
    <AppContextProvider>
      <BrowserRouter>
        <Snowfall />
        <ThemeSwitcher />
        <Navigation />
        <Routes />
      </BrowserRouter>
    </AppContextProvider>
  );
}

export default App;
